import React, {useMemo} from "react";
import {Link} from "react-router-dom";
import {useHtmlClassService} from "../../_core/MetronicLayout";

export function Footer() {
  const today = new Date().getFullYear();
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      footerClasses: uiService.getClasses("footer", true),
      footerContainerClasses: uiService.getClasses("footer_container", true)
    };
  }, [uiService]);

  return (
    <div
      className={`footer bg-white py-4 d-flex flex-lg-column  ${layoutProps.footerClasses}`}
      id="kt_footer"
    >
      <div
        className={`${layoutProps.footerContainerClasses} container-frontend d-flex flex-column flex-md-row align-items-center justify-content-between`}
      >
        <div className="text-dark order-2 order-md-1">
          <span className="text-muted font-weight-bold mr-2">{today.toString()}</span> &copy;{" "}
          <a
            href="#"
            target="_blank"
            rel="noopener noreferrer"
            className="text-dark-75 text-hover-primary"
          >
            Allez
          </a>
        </div>
        <div className="nav nav-dark order-1 order-md-2">
        <div className="d-flex">
          <Link to="/privacy" >
            Privacy
          </Link>
          <Link to="/terms" className="ml-10">
            Terms & Conditions
          </Link>
          <Link to="/about" className="ml-10">
            About
          </Link>
        </div>
        </div>
      </div>
    </div>
  );
}
